import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StorageService } from '@shared/services/storage.service';
import { FileDisplayType } from '../../enums/file-display-type.enum';

@Component({
  selector: 'app-file-browser-list-switch',
  templateUrl: './file-browser-list-switch.component.html',
  styleUrls: ['./file-browser-list-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileBrowserListSwitchComponent implements OnInit {
  @Input() displayType: FileDisplayType = FileDisplayType.PREVIEW_BLOCKS;
  @Output() displayTypeChange = new EventEmitter<FileDisplayType>();

  protected displayTypes = FileDisplayType;

  constructor(
    private storage: StorageService
  ) { }

  ngOnInit(): void {
    this.displayType = this.displayType || this.storage.getStorage(this.storage.fileBrowserView) || FileDisplayType.LIST;
    this.displayTypeChange.next(this.displayType);
  }

  private saveChange(): void {
    this.storage.setStorage(this.displayType.toString(), this.storage.fileBrowserView);
    this.displayTypeChange.next(this.displayType);
  }
  
  protected setList(): void {
    this.displayType = FileDisplayType.LIST;
    this.saveChange();
  }

  protected setBlocks(): void {
    this.displayType = FileDisplayType.PREVIEW_BLOCKS;
    this.saveChange();
  }
}
